import { client } from '../utils/fetch';
import { SystemLog } from '../types/SystemLog';

export const getSystemLogs = async (): Promise<SystemLog[]> => {
  const headers = {
    'Content-Type': 'application/json;charset=UTF-8',
  };

  try {
    const url = 'logs/system';
    const response = await client.get<SystemLog[]>(url, headers);
    return response;
  } catch (error) {
    console.error("Error fetching system logs:", error);
    throw error;
  }
}; 